import { Button, customScrollMinimal } from '@toggle/design-system';
import styled, { css } from 'styled-components';

import { EmptyInsightsCell } from '../empty-insights-cell/EmptyInsightsCell';

export const ScenarioTableRoot = styled.div`
  ${customScrollMinimal};
  overflow: auto;
  flex: 1 1 0;
  z-index: 1;
`;

export const TableRoot = styled.table<{ $disabled: boolean }>`
  border-spacing: 0;
  width: 100%;
  --z-index-header-cell: 2;
  --z-index-table-cell: 1;

  th:first-child {
    width: 15%;
  }
  th {
    border-bottom: 1px solid var(--border-default);
  }
  td {
    width: 250px;
    overflow: hidden;
  }
  tr:last-child {
    > td {
      border-bottom: 1px solid var(--border-default);
    }
  }

  ${({ $disabled }) =>
    !$disabled &&
    css`
      tbody tr {
        cursor: pointer;
      }
      tbody tr:hover {
        background-color: var(--surface-hover);
        td {
          background-color: var(--surface-hover);
          [aria-haspopup='true'] {
            border-bottom: 1px dashed var(--border-default);
          }
        }
      }
    `}
`;

export const StyledAddAssetRow = styled.tr`
  &&&& {
    border-bottom: none;
    &:hover {
      background-color: var(--background-default);
    }

    td {
      border-bottom: none;
      padding-top: 8px;
      padding-bottom: 4px;
      &:hover {
        background-color: var(--background-default);
      }
    }
  }
`;

export const InsightsWrapper = styled.span`
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 0.02rem;
`;

export const TickerCell = styled.div`
  display: flex;
  gap: 8px;
`;

export const WrapperEmptyAssetsState = styled.div`
  padding: 60px 0px;
  ${EmptyInsightsCell.Styled.Description} {
    max-width: 446px;
  }
`;

export const StyledButton = styled(Button)`
  margin-top: 16px;
`;
